import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChevronRight, Database } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

/** A dataset to answer with: its name, a few facts; tap to use it. */
export const DatasetChoiceRow = memo(
  ({
    name,
    facts,
    hint,
    disabled,
    onPress,
  }: {
    name: string;
    /** e.g. rows, uploader, last used; empty ones are left out. */
    facts: Array<string | null>;
    /** e.g. 最匹配, on the first one. */
    hint?: string;
    disabled: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const line = facts.filter(Boolean).join(' · ');
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={`用「${name}」这份数据`}
        accessibilityState={{ disabled }}
        disabled={disabled}
        onPress={onPress}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(10),
          paddingHorizontal: rpx(12),
          paddingVertical: rpx(10),
          borderRadius: rpx(11),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: pressed ? aiColors.muted : aiColors.card,
          opacity: disabled ? 0.55 : 1,
        })}
      >
        <View
          style={{
            width: rpx(28),
            height: rpx(28),
            borderRadius: rpx(8),
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: tint(aiColors.amber, 0.14),
          }}
        >
          <Database size={15} color={aiColors.amber} />
        </View>
        <View style={{ flex: 1, gap: rpx(2) }}>
          <Typography.Text
            size={rpx(14)}
            color={aiColors.foreground}
            numberOfLines={1}
          >
            {name}
          </Typography.Text>
          {line ? (
            <Typography.Text
              size={rpx(11)}
              color={aiColors.mutedForeground}
              numberOfLines={1}
            >
              {line}
            </Typography.Text>
          ) : null}
        </View>
        {hint ? (
          <Typography.Text size={rpx(11)} color={aiColors.primary}>
            {hint}
          </Typography.Text>
        ) : null}
        <ChevronRight size={16} color={aiColors.mutedForeground} />
      </Pressable>
    );
  },
);
